// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__160Aj","col":"styles_col__24RIR"};